// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/bg-element.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SIFI FK STYLES */
:root {
  /* override variables */
  --psp-dark: #010036;
  --psp-primary: #006EAB;
  --psp-accent: #F47639;
  --psp-border-radius: 20px;
  --psp-border-width-btn: 2px;
  --psp-font-family: "SF Pro Display", sans-serif;
  --bs-font-sans-serif: var(--psp-font-family);
  --psp-button-font-family: "Inter", sans-serif;
}

body::before, body::after {
  content: "";
  position: fixed;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  width: 200px;
  height: 200px;
  background-repeat: no-repeat;
  background-size: contain;
  z-index: -1;
}
body::before {
  bottom: 10vh;
  left: -110px;
}
body::after {
  top: 10vh;
  right: -180px;
  width: 250px;
  height: 250px;
}
body.bg-body-secondary::before, body.bg-body-secondary::after {
  opacity: 0.2;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
